import apiFetch from '../apiFetch'

export default function (extraSaleValues, uoId, token) {
  const body = {
    organizedUnitId: uoId,
    isDeleted: false,
    extraSaleTypeLanguages: extraSaleValues
  }
  return apiFetch({
    endPoint: 'extraSaleType',
    method: 'POST',
    body: body,
    token: token
  })
}
